

import React from 'react';
import { compose } from 'recompose';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

import { withLocale } from 'op/components/locale';
import {withOnlineStatus} from 'op/components/offline';

const ActionBar = styled.div`
	display: inline;
  position: fixed;
  top: calc(100vh - 20px - 4em);
  ${props => props.direction || 'right'}: 20px;
  z-index: 3000;
  -webkit-backface-visibility: hidden;
`;

const CreateButton = ({ match, locale, online }) => (
  <ActionBar direction={ locale._meta.rtl ? 'left' : 'right' } >
    <Button icon='plus' circular size='huge' primary as={Link} to={`/person/${match.params.person_id}/report`} disabled={!online} />
  </ActionBar>
);

export default compose(
  withLocale(),
    withOnlineStatus,
  hot(module)
)(CreateButton);